import { P2GBox } from '@parcel2go/core-ui';
import { P2GGrid } from '@parcel2go/core-ui';
import { ReactNode } from 'react';
import { SmartSendItemApiModel } from '~/lib/api/smartsend/types';
import { EditType } from './EditType';
import MarketplaceActions from './MarketplaceActions';
import { ItemActionType } from './SetMarketplaceAction';

interface mobileProps {
  ready?: ReactNode;
  item: SmartSendItemApiModel;
  removeTag: (tag: string) => void;
  saveTags: (tags: string[]) => void;
  edit?: (type: EditType) => void;
  action?: (type: ItemActionType) => void;
}

export function ItemMarketplaceDetailsMobile(props: mobileProps) {
  return (
    <P2GBox p={1}>
      <P2GGrid container spacing={1} alignItems="center" justify="space-between" wrap="nowrap">
        <P2GGrid item flexShrink={1}>
          <P2GGrid container spacing={1} alignItems="center" justify="space-between" wrap="nowrap">
            <MarketplaceActions {...props} size="small" />
          </P2GGrid>
        </P2GGrid>
        {props.ready && (
          <P2GGrid item textAlign="right">
            {props.ready}
          </P2GGrid>
        )}
      </P2GGrid>
    </P2GBox>
  );
}
